import { squaresApi } from '../../../api';
import type { Square, ClaimSquareInput } from '../../../types';
import type { SquareStateGetter } from '../types';

export const createClaimSquare = (get: SquareStateGetter) => {
  return async (boardId: string, input: ClaimSquareInput): Promise<Square> => {
    const square = await squaresApi.claim(boardId, input);
    await get().fetchSquares(boardId);
    return square;
  };
};
